import { render, staticRenderFns } from "./TrainingFae.vue?vue&type=template&id=9c422f7e&"
import script from "./TrainingFae.vue?vue&type=script&lang=js&"
export * from "./TrainingFae.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports